export const getBackerName = ({ shipping, email }) => {
    if (!shipping.address) {
        return email;
    }
    const { firstName, lastName } = shipping.address;
    return [firstName, lastName].filter(Boolean).join(' ');
};
